<div id="backdrop"></div>
<div id="floaters" aria-hidden="true"></div>

<div class="container">
    <div class="wrapper">
        <div class="logo-container">
            <img [src]="themeService.getLogoPath()" alt="Sequal logo" class="logo" />
        </div>

        <div class="content">
            <span class="badge">Coming soon</span>

            <h1>We're almost there</h1>

            <p class="description">
                Sequal is launching soon. Be the first to know the moment we go live.
            </p>

            <div class="buttons">
                <a class="btn"
                    href="mailto:connect@sequal.app?subject=Sequal%20Early%20Access%20Interest&body=Hi%2C%20I%27d%20like%20early%20access%20to%20Sequal.">
                    <span class="btn-text">Notify me</span>
                </a>
            </div>
        </div>
    </div>
</div>
